import api from "../Api.js";
import util from "../../util/Util.js";

export default () => {
  async function getConfigPersonalizada() {
    const nomeCliente = util().getClienteFromUrl();
    return await api().get(`/config-personalizada/${nomeCliente}`);
  }

  function atualizarCatalogo(catalogoAtivo) {
    return api().put(
      `/config-personalizada/atualizar-catalogo/${catalogoAtivo}`
    );
  }

  function atualizarBot(botAtivo) {
    return api().put(`/config-personalizada/atualizar-bot/${botAtivo}`);
  }

  function abrirBot(botAberto) {
    return api().put(`/config-personalizada/abrir-bot/${botAberto}`);
  }

  function enviarMensagemWhatsapp(whatsapp) {
    return api().put(
      `/config-personalizada/enviar-mensagem-whatsapp/${whatsapp}`
    );
  }

  function ativarCamposObrigatorios() {
    return api().get(`/config-personalizada/obrigatorios/campos`);
  }

  function atualizarInterfaceCards(inter) {
    return api().put(`/config-personalizada/interface/${inter}`);
  }

  function atualizarTooltipSessao(tooltip) {
    return api().put(`/config-personalizada/tooltip/${tooltip}`);
  }

  return {
    getConfigPersonalizada,
    atualizarCatalogo,
    atualizarBot,
    abrirBot,
    enviarMensagemWhatsapp,
    ativarCamposObrigatorios,
    atualizarInterfaceCards,
    atualizarTooltipSessao
  };
};
